/**
 * Client-side error reporting for ErrorBoundary (and optional Sentry).
 * Logs with prefix [GolfLists ErrorBoundary] for grep in Netlify / prerender logs.
 */

import * as Sentry from '@sentry/react';

/**
 * Call once from index.js before render when DSN is set.
 */
export function initClientErrorReporting() {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) return;
  Sentry.init({
    dsn,
    environment: process.env.NODE_ENV,
    enabled: process.env.NODE_ENV === 'production',
    tracesSampleRate: 0,
  });
}

/**
 * @param {Error} error
 * @param {{ componentStack?: string }} [errorInfo]
 * @param {{ pathname?: string }} [extra]
 */
export function reportClientError(error, errorInfo, extra = {}) {
  const pathname =
    extra.pathname ||
    (typeof window !== 'undefined' ? window.location.pathname : '');
  const ua =
    typeof navigator !== 'undefined' ? navigator.userAgent || '' : '';

  const payload = {
    name: error?.name,
    message: error?.message,
    stack: error?.stack,
    componentStack: errorInfo?.componentStack,
    pathname,
    userAgent: ua,
  };

  // Single-line message first so Netlify / prerender function logs stay grep-friendly.
  console.error(
    '[GolfLists ErrorBoundary]',
    error?.message || error,
    errorInfo?.componentStack ? '\n' + errorInfo.componentStack : '',
  );
  console.error('[GolfLists ErrorBoundary:detail]', payload);

  if (process.env.REACT_APP_SENTRY_DSN && process.env.NODE_ENV === 'production') {
    Sentry.captureException(error, {
      contexts: {
        react: { componentStack: errorInfo?.componentStack || '' },
        route: { pathname },
      },
      extra: { userAgent: ua },
    });
  }
}
